import React, { useEffect, useState, useCallback } from "react";
import { getStaffListApi } from "../../api/staffService";
import Button from "../../utils/Buttons";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination/Pagination";
function StaffList(props) {
  const userId = props.userId;
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const loadStaff = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getStaffListApi({
        page: currentPage,
        pageSize: itemsPerPage,
      });
      const data = Array.isArray(res?.data) ? res.data : [];
      setStaff(data);
      setTotalItems(res?.pagination?.totalItems || data.length);
    } catch (error) {
      console.log(error);
      setStaff([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  }, [currentPage, itemsPerPage]);
  useEffect(() => {
    loadStaff();
  }, [loadStaff]);
  const handleAddStaff = () => {
    navigate("/staff/add", { state: { userId } });
  };
  const handleEdit = (staffId) => {
    navigate(`/staff/edit/${staffId}`, { state: { userId: userId, staffId } });
  };
  const handleView = (staffId) => {
    navigate(`/staff/view/${staffId}`, { state: { userId: userId, staffId } });
  };

  return (
    <div className="container p-4 np-staff-page">
      <div className="d-flex justify-content-between align-items-center mb-2">
          
          {JSON.parse(localStorage.getItem("user"))?.role === "ADMIN" && (
            <Button
              text="Add Staff"
              icon={<FiPlus size={15} />}
              className="btn btn-primary"
              onClick={handleAddStaff}
            />
          )}
        </div>
      <div className="card p-3">
        
        {loading ? (
          <p>Loading...</p>
        ) : (
          <table className="table table-bordered table-hover">
            <thead className="bg-light">
              <tr>
                <th className="text-dark fw-bold">Name</th>
                <th className="text-dark fw-bold">Email</th>
                <th className="text-dark fw-bold">Status</th>
                <th className="text-dark fw-bold">Role</th>
                {JSON.parse(localStorage.getItem("user"))?.role === "ADMIN" && (
                  <th className="text-dark fw-bold">Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {staff.length === 0 ? (
                <tr>
                  <td colSpan="5">No Staff Found</td>
                </tr>
              ) : (
                staff.map((item) => (
                  <tr key={item._id}>
                    <td>{item.fullName}</td>
                    <td>{item.email}</td>
                    <td>
                      <Button
                        text={item.status}
                        className={`badge ${
                          item.status === "ACTIVE" ? "bg-success" : "bg-secondary"
                        } m-2 p-2 border-0`}
                      />
                    </td>
                    <td>{item.role}</td>
                    {JSON.parse(localStorage.getItem("user"))?.role === "ADMIN" && (
                      <td className="text-center">
                        <Button
                          icon={<i className="fe fe-eye"></i>}
                          className="btn btn-sm np-table-action-btn me-2"
                          onClick={() => handleView(item._id)}
                        />
                        <Button
                          icon={<i className="fe fe-edit"></i>}
                          className="btn btn-sm np-table-action-btn"
                          onClick={() => handleEdit(item._id)}
                        />

                      </td>
                    )}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
        <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
    </div>
  );
}
export default StaffList;
